import React from 'react'
import tw, { styled } from 'twin.macro'
import { useStateContext } from '../context/stateContext'
import content from './../data/content.json'
import parse from 'html-react-parser'
import { motion } from 'framer-motion'
import useWindowSize from '../hooks/useWindowSize'
import Sound from '../components/Sound'
import outroCats from '../assets/outro-cats_big.png'
import HighScores from './HighScores'

const Container = styled(motion.div)`
	${tw`fixed top-0 bottom-0 w-full h-full overflow-hidden`}
`
const Wrap = styled.div`
	${tw`flex flex-col-reverse justify-center h-full md:flex-row`}
`
const Headline = styled.h1`
	${tw`mb-8 text-2xl font-extrabold text-center text-yellow xs:text-3xl mobile:text-4xl md:text-7xl`}
`
const Description = styled.p`
	${tw`mb-8 text-xl text-center text-green`}
`
const OutroCats = styled.img`
	transform-origin: 80% 50%;
	${tw`absolute bottom-0 transform w-full scale-125 sm:scale-100 sm:left-0 sm:right-0 sm:w-10/12 mx-auto z-[-5]`}
`
const Score = styled.div`
	${tw`flex justify-center w-full mx-auto my-0 xs:my-8`}

	& .result {
		${tw`flex items-center justify-center w-10 h-10 mx-auto text-6xl font-normal text-center text-white xs:w-14 xs:h-14 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-xl md:text-8xl`}

		&-wrap {
			${tw`flex flex-col items-center mx-3`}

			.label {
				${tw`mt-3 text-lg font-semibold text-white uppercase`}
			}
		}
	}
`
const ButtonWrap = styled.div`
	${tw`flex flex-wrap justify-center gap-5`}
`

const Main = styled(motion.div)`
	${tw`relative flex flex-col justify-center w-full py-10 h-3/5 md:h-auto md:py-0`}

	& .content {
		${tw`z-10 w-full px-5 mx-auto text-center mb-14 md:mb-0 md:px-0 md:w-4/5 xl:w-3/5 md:text-left`}

		h1, p {
			@media screen and (max-width: 350px) {
				${tw`mb-4`}
			}
		}

		p {
			${tw`text-lg leading-normal md:text-xl`}
		}
	}

	& .legals {
		${tw`absolute z-10 hidden w-3/5 text-xs transform -translate-x-1/2 md:block left-1/2 bottom-10 text-darkGray`}

		a:first-of-type {
			${tw`pr-6 border-r border-black`}
		}

		a:not(:first-of-type) {
			${tw`px-6`}
		}
	}
`

const EndScreen = () => {
	const stateContext = useStateContext()
	const { locale } = stateContext.state
	const t = content.langs
	const { isMobile } = useWindowSize()

	const [highScoresView, setHighScoresView] = React.useState(true)

	const onRestartGame = async () => {
		stateContext.dispatch({ action: 'SET_GAME_STATUS', data: 'gameStart' })
		await new Promise((resolve) =>
			setTimeout(() => {
				return resolve()
			}, 600)
		)
		stateContext.dispatch({ action: 'RESET_GAME' })
	}

	const mainVariants = {
		init: {
			y: isMobile ? '150%' : '-150%',
		},
		animate: {
			y: '0%',
			transition: {
				duration: 0.7,
			},
		},
		exit: {
			y: isMobile ? '150%' : '-150%',
			transition: {
				duration: 0.7,
			},
		},
	}

	return (
		<Container>
			<Sound mode='home' mobile={true} />
			<Wrap>
				<Main variants={mainVariants} initial='init' animate='animate' exit='exit'>
					<Sound mode='home' />
					{!highScoresView && (
						<div className='content'>
							<Headline>{parse(t[locale].endHeadline)}</Headline>
							<Score>
								<div className='result-wrap'>
									<div className='result'>{stateContext.state.finalScore.pairs}</div>
									<p className='label'>{stateContext.state.finalScore.pairs === 1 ? t[locale].pairs[0] : t[locale].pairs[1]}</p>
								</div>
								<div className='result-wrap'>
									<div className='result'>{stateContext.state.finalScore.rounds}</div>
									<p className='label'>{stateContext.state.finalScore.rounds === 1 ? t[locale].rounds[0] : t[locale].rounds[1]}</p>
								</div>
							</Score>
							{/* <Description>{parse(t[locale].endDescription)}</Description> */}
							<ButtonWrap>
								<button className='bg-pink text-white md:text-lg py-2 md:py-4 px-4 uppercase md:tracking-wider w-[240px]' onClick={() => setHighScoresView(true)}>
									{t[locale].submitScoreButton}
								</button>
								<button className='bg-transparent text-white border border-pink md:text-lg py-2 md:py-4 px-4 uppercase md:tracking-wider w-[240px]' onClick={() => onRestartGame()}>
									{t[locale].endRestartButton}
								</button>
							</ButtonWrap>
						</div>
					)}
					{highScoresView && (
						<div className='content'>
							<HighScores userScore={stateContext.state.finalScore} />
						</div>
					)}
				</Main>
				<OutroCats src={outroCats} alt='' />
			</Wrap>
		</Container>
	)
}

export default EndScreen
